// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../orca-ui/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../orca-ui/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#media-components-scrubber #media-components-scrubber-bar {
  position: relative;
  border-radius: 3px;
  height: 4px;
}
#media-components-scrubber #media-components-scrubber-dot {
  min-width: 10px;
  min-height: 10px;
  margin-left: -4px;
  background-color: inherit;
  transform: scale(0);
  transition: transform 0.1s cubic-bezier(0.4, 0, 1, 1);
  border-radius: 50%;
  position: relative;
  box-sizing: border-box;
  user-select: none;
  transition-property: transform;
  transition-duration: var(--motion-duration-200);
}

#media-components-scrubber:hover #media-components-scrubber-dot {
  transform: scale(1);
}
`, "",{"version":3,"sources":["webpack://./../components/src/common/scrubber.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,qDAAqD;EACrD,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["#media-components-scrubber #media-components-scrubber-bar {\n  position: relative;\n  border-radius: 3px;\n  height: 4px;\n}\n#media-components-scrubber #media-components-scrubber-dot {\n  min-width: 10px;\n  min-height: 10px;\n  margin-left: -4px;\n  background-color: inherit;\n  transform: scale(0);\n  transition: transform 0.1s cubic-bezier(0.4, 0, 1, 1);\n  border-radius: 50%;\n  position: relative;\n  box-sizing: border-box;\n  user-select: none;\n  transition-property: transform;\n  transition-duration: var(--motion-duration-200);\n}\n\n#media-components-scrubber:hover #media-components-scrubber-dot {\n  transform: scale(1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
